<script>
import Swal from "sweetalert2";
import axios from "axios";
import $ from "jquery";

export default {
  name: "form-import-peserta",
  data() {
    return {
      file_excel: null,
      peserta_data: [],
    };
  },
  mounted() {},
  methods: {
    downloadFileTemplate() {
      const link = document.createElement("a");
      link.href =
        "/template_excel/template_peserta.xlsx";
      link.download =
      "/template_excel/template_peserta.xlsx";
      link.click();
    },
    uploadFile() {
      let self = this;
      if ($("#importexcel")[0].files[0]) {
        if ($("#importexcel")[0].files[0].size < 2242880) {
          if (
            $("#importexcel")[0].files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            $("#uploadLoading").html(
              '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
            );
            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#importexcel")[0].files[0]);
            var config = {
              method: "post",
              url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
              },
              data: data,
            };
            axios(config).then(function (response) {
              console.log(response.data.data.path_file);
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoading").html(
                '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                  urlres +
                  '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
              );
              self.file_excel = path_file;
            });
          } else {
            $("#uploadLoading").html(
              '<span class="badge bg-danger p-1"><i class="fa fa-times"></i> Tipe File Wajib XLSX.</span> '
            );
          }
        } else {
          $("#uploadLoading").html(
            '<span class="badge bg-danger p-1"><i class="fa fa-times"></i> Gagal Upload File, maksimum ukuran file 2 Mb.</span> '
          );
        }
      }
    },
    StoreData() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      if (self.file_excel == null) {
        Swal.close();
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "Mohon unggah file excel.",
        });
      } else {
        var config_store_data = {
          method: "post",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "transactions/pembelajaran/import-peserta",
          data: {
            path_file: self.file_excel,
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        };
        axios(config_store_data)
          .then(function (response) {
            var response_data = response.data;
            if (response_data.error == null) {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil di import",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  Swal.close();
                  var pesertanya = JSON.parse(response_data.data.peserta_data);
                  console.log(pesertanya);
                  self.$emit("init-data-peserta", JSON.stringify(pesertanya));
                }
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.message,
              });
            }
          })
          .catch(function (error) {
            self.axiosCatchError = error.response.data.data;
            Swal.close();
          });
      }
    },
  },
};
</script>
<template>
  <b-form class="p-2" @submit.prevent="StoreData">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="Kode">Import File Excel</label>
          <input
            class="form-control"
            type="file"
            id="importexcel"
            @change="uploadFile"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
          <span class="text-danger">Max size 10mb. Format .xlsx</span>
          
        </div>
        <div class="respond-input-file float-left" id="uploadLoading"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2">&nbsp;</div>
      <!-- end col -->
      <div class="col-lg-10">
        <div class="text-end">
          <button
            type="button"
            class="btn btn-success"
            @click="downloadFileTemplate"
          >
            <i class="dripicons-article"> </i>
            Download Template Excel
          </button>
          &nbsp;
          <b-button type="reset" variant="danger">
            <i class="fa fa-redo-alt"></i> Reset
          </b-button>
          &nbsp;
          <b-button type="submit" variant="primary">
            <i class="fa fa-save"></i> Simpan
          </b-button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </b-form>
</template>
